(function () {
  'use strict';
  if (!document.body.classList.contains('tld-template')) return;

  function reparentBadges(root) {
    var scope = root || document;
    var cards = scope.querySelectorAll('.product-grid-item');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var cell = card.querySelector('.product-grid-item__image');
      var badge = card.querySelector('.product__badge');
      if (cell && badge && badge.parentNode !== cell) {
        cell.appendChild(badge);
      }
    }
  }

  function watchBadges() {
    reparentBadges();
    if (!window.MutationObserver) return;
    var target = document.querySelector('[data-collection-products]') || document.body;
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          reparentBadges();
          return;
        }
      }
    }).observe(target, { childList: true, subtree: true });
  }

  function sortBar() {
    if (!document.body.classList.contains('tld-collection')) return;
    var wrap = document.querySelector('[data-collection-products]');
    if (!wrap) return;
    var grid = wrap.querySelector('.grid') || wrap;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.product-grid-item'));
    if (cards.length < 2) return;

    cards.forEach(function (card, i) {
      card.dataset.tldOrder = i;
      var badge = card.querySelector('.product__badge__item--saving');
      var pct = 0;
      if (badge) {
        var m = (badge.textContent || '').match(/(\d+)\s*%/);
        if (m) pct = parseInt(m[1], 10);
      }
      card.dataset.tldSavings = pct;
    });

    function reorder(bySavings) {
      var sorted = cards.slice().sort(function (a, b) {
        if (bySavings) return (b.dataset.tldSavings - 0) - (a.dataset.tldSavings - 0);
        return (a.dataset.tldOrder - 0) - (b.dataset.tldOrder - 0);
      });
      sorted.forEach(function (c) { grid.appendChild(c); });
    }

    var bar = document.createElement('div');
    bar.className = 'tld-savings-sortbar';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'tld-sort-saving';
    btn.setAttribute('aria-pressed', 'false');
    btn.textContent = 'Sort by savings';
    var on = false;
    btn.addEventListener('click', function () {
      on = !on;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      reorder(on);
    });
    bar.appendChild(btn);

    var mq = window.matchMedia ? window.matchMedia('(max-width: 768px)') : null;
    function place() {
      var mobile = mq ? mq.matches : (window.innerWidth <= 768);
      if (mobile) {
        bar.className = 'tld-savings-sortbar tld-savings-sortbar--mobile';
        var stickyBar = document.querySelector('[data-collection-sticky-bar]') ||
                        document.getElementById('CollectionStickyBar');
        if (stickyBar && stickyBar.parentNode) {
          stickyBar.parentNode.insertBefore(bar, stickyBar.nextSibling);
          return;
        }
      }
      bar.className = 'tld-savings-sortbar';
      var filters = document.querySelector('[data-collection-filters-list]') ||
                    document.querySelector('.collection__filters-list__inner') ||
                    document.querySelector('.collection__filters');
      if (filters) filters.insertBefore(bar, filters.firstChild);
      else wrap.insertBefore(bar, wrap.firstChild);
    }
    place();
    if (mq) {
      var onChange = function () { place(); };
      if (mq.addEventListener) mq.addEventListener('change', onChange);
      else if (mq.addListener) mq.addListener(onChange);
    }
  }

  function init() {
    watchBadges();
    sortBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { reparentBadges(e.target); });
})();
